(()=>{
  if(window.__pbvimg)return;
  window.__pbvimg=1;
  const current=document.currentScript;
  if(!current)return;

  const syncNativeVariant=event=>{
    const input=event.target;
    if(!(input instanceof HTMLInputElement)||input.name!=='id')return;
    const selector=input.closest('product-variant-selector');
    if(!selector||input!==selector.querySelector('input[name="id"]'))return;

    event.stopImmediatePropagation();

    const variantId=String(input.value||'');
    const nativeVariant=Array.isArray(selector.variants)
      ? selector.variants.find(variant=>String(variant.id)===variantId)
      : null;

    if(!nativeVariant||String(selector.variant?.id||'')===variantId)return;

    selector.variant=nativeVariant;
    selector.currentOptions=[...nativeVariant.options];
    selector.setAttribute('variant-id',variantId);

    if(typeof selector._setOptionsAvailability==='function'){
      selector._setOptionsAvailability();
    }

    if(typeof selector._publishChanges==='function'){
      Promise.resolve(selector._publishChanges()).catch(()=>{});
    }

    if(selector.isProductPage&&typeof selector._updateHistory==='function'){
      selector._updateHistory();
    }
  };

  document.addEventListener('change',syncNativeVariant,true);

  const coreUrl=new URL(current.src);
  coreUrl.pathname=coreUrl.pathname.replace(/a3819c1a23\.js$/,'5d41c8e27b.js');
  coreUrl.search='';
  const loader=document.createElement('script');
  loader.src=coreUrl.href;
  loader.onload=()=>{
    const initMedia=root=>{
      if(!root||root.dataset.pbVariantMediaReady==='1')return;
      const selector=document.querySelector('product-variant-selector[product-page]')||document.querySelector('product-variant-selector');
      const variantInput=selector?.querySelector('input[name="id"]');
      const variantsJson=selector?.querySelector('[data-variants-json]');
      if(!variantInput||!variantsJson)return;
      let variants;
      try{variants=JSON.parse(variantsJson.textContent||'[]');}catch(error){return;}
      const positions=new Map(variants.map(variant=>[
        String(variant.id),
        Number.parseInt(variant.featured_media?.position,10)||0
      ]));
      const gallery=()=>document.querySelector('product-gallery');
      const show=(position,attempt=0)=>{
        if(!Number.isInteger(position)||position<1)return;
        const slider=gallery()?.slider||gallery()?.swiper;
        if(slider?.slideTo){slider.slideTo(position-1);return;}
        if(attempt<20)window.setTimeout(()=>show(position,attempt+1),50);
      };
      const sync=()=>{
        const position=positions.get(String(variantInput.value))||0;
        if(position>0)show(position);
      };
      variantInput.addEventListener('input',sync);
      variantInput.addEventListener('change',sync);
      root.dataset.pbVariantMediaReady='1';
      sync();
    };

    const hideNativePrice=(root,attempt=0)=>{
      if(!root)return;
      if(root.dataset.ready!=='1'||root.hidden){
        if(attempt<40)window.setTimeout(()=>hideNativePrice(root,attempt+1),50);
        return;
      }
      const selector=document.querySelector('product-variant-selector[product-page]')||document.querySelector('product-variant-selector');
      const productSection=selector?.closest('.shopify-section')||document.querySelector('form[action*="/cart/add"]')?.closest('.shopify-section');
      const priceNode=productSection?.querySelector('.\\#product-price');
      const priceBlock=priceNode?.closest('[data-meta-block]');
      if(priceBlock){
        priceBlock.hidden=true;
        priceBlock.dataset.pbHiddenPrice='1';
      }
    };

    const initAll=scope=>scope.querySelectorAll?.('[data-pb-configurator]').forEach(root=>{
      initMedia(root);
      hideNativePrice(root);
    });

    initAll(document);
    document.addEventListener('shopify:section:load',event=>initAll(event.target));
    document.addEventListener('shopify:section:unload',()=>{
      document.querySelectorAll('[data-pb-hidden-price="1"]').forEach(block=>{
        block.hidden=false;
        delete block.dataset.pbHiddenPrice;
      });
    });
  };
  document.head.appendChild(loader);
})();
